export interface IAuthToken {
  id?: number;
  accessToken?: string | null;
  expiresIn?: number | null;
}

export const defaultValue: Readonly<IAuthToken> = {};
